/*
 * Copyright (c) 2019, Ahmed Allem <ahmed.allem@gmail.com>
 *
 * License: MIT
 */

export default {
  PLUGIN_NAME: "click_imagepicker",
  PLUGIN_TYPE: "click_imagepicker"
};
